import AddExporter from './add-exporter';

export default {
  __init__: [ AddExporter ]
};